import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { tableModel } from './model/tableModel';
import { columnModel } from './model/columnModel';
import { MatPaginator } from '@angular/material/paginator';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';


@Component({
  selector: 'app-table',
  standalone: false,
  templateUrl: './table.component.html',
  styleUrl: './table.component.css'
})
export class TableComponent {
  @ViewChild(MatTable) tableComponent:MatTable<any>;
  @Output() editEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() detailEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() paginatorEvent: EventEmitter<any> = new EventEmitter<any>();

  @Input() tableModel!: tableModel;
  
  //dataSource : any[] = [];
  dataSource = new MatTableDataSource<any>();
  columnName : string[] = [];
  columnData : columnModel[] = [];
  pageOption : number[] = [5, 10,20,50];
  //pageNumber : number = 0;
  totalRecords : number = 0;
  
  constructor(private paginator: MatPaginatorIntl){
    this.tableComponent=new MatTable();
    paginator.itemsPerPageLabel = 'Elementos por Pagina: ';
    paginator.firstPageLabel = 'Primer pagina';
    paginator.lastPageLabel = 'Ultima pagina';
    paginator.nextPageLabel = 'Pagina siguiente';
    paginator.previousPageLabel = 'Pagina anterior';
    paginator.getRangeLabel = (page: number, pageSize: number, length: number) => {
      const start = page * pageSize + 1;
      const end = (page + 1) * pageSize;
      return `${start} - ${end} de ${this.totalRecords}`;
    };
  }

  public initTable(){
    //this.pageNumber = 0;
    this.totalRecords = 0;
    
    if(this.tableModel != null || this.tableModel != undefined){
      //this.dataSource = this.tableModel.dataSource;
      this.dataSource.data = this.tableModel.dataSource;
      //this.pageNumber = this.tableModel.pageNumber ?? 1;
      //this.totalRecords = this.dataSource.length;
      this.totalRecords = this.tableModel.totalRecords != null ? this.tableModel.totalRecords : 0;
      this.columnData = this.tableModel.columnModel;
      if(this.tableModel.pageOptions != null || this.tableModel.pageOptions != undefined){
        this.pageOption = this.tableModel.pageOptions;  
      }
      this.columnName = this.tableModel.columnModel.map(col => col.columnValue);
      if(this.tableModel.editButton){
        this.columnName.push("editar");
      }
      if(this.tableModel.deleteButton){
        this.columnName.push("eliminar");
      }
      if(this.tableModel.viewDetail){
        this.columnName.push("verDetalle");
      }
    }
  }

  public refresh(_dataSource? : any[], _totalRecords?: number){
    
    if(_totalRecords != null || _totalRecords != undefined){
      this.totalRecords = _totalRecords; 
    }
    if(_dataSource != null || _dataSource != undefined){
      //this.dataSource = _dataSource; 
      this.dataSource.data = _dataSource;
    }
    if (this.tableModel) {
      this.columnData = this.tableModel.columnModel ?? [];
      this.columnName = this.columnData.map(col => col.columnValue);
  
      if (this.tableModel.editButton) {
        this.columnName.push('editar');
      }
      if (this.tableModel.deleteButton) {
        this.columnName.push('eliminar');
      }
      if (this.tableModel.viewDetail) {
        this.columnName.push('verDetalle');
      }
  
      if (this.tableModel.pageOptions) {
        this.pageOption = this.tableModel.pageOptions;
      }
    }
    this.tableComponent.renderRows();
  }

  public paginatorChange(event: any) {
    this.paginatorEvent.emit(event);
  }

  public delete(element: any){
    this.deleteEvent.emit(element);
  }

  public edit(element:any){ 
    this.editEvent.emit(element);
  }

  public detail(element:any){ 
    this.detailEvent.emit(element);
  }
}